export default __webpack_public_path__ + "static/why-1-dfcf6ad62b80b9273b2cb713cf7cc4a2.png";